import { render } from "./btmFooter.vue?vue&type=template&id=22aec3df&scoped=true"
import script from "./btmFooter.vue?vue&type=script&lang=js"
export * from "./btmFooter.vue?vue&type=script&lang=js"

import "./btmFooter.vue?vue&type=style&index=0&id=22aec3df&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jomon\\OneDrive\\Desktop\\algorithma-website-master\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22aec3df"]])

export default __exports__